import accordion from './core/accordion';
import contactForms from './core/contact-forms';
import iconSystem from './core/icon-system';
import navigation from './core/navigation';
import notifications from './core/notification-bar';
import products from './core/products';
import woocommerce from './core/woocommerce';
import cart from './core/cart';
import ajaxLoader from './core/ajax-loader';
import searchFilters from './core/search-filters';
import clearFilters from './core/filters';
import { AutoComplete } from './core/autocomplete';

document.addEventListener('DOMContentLoaded', function () {
	accordion();
	contactForms();
	iconSystem();
	navigation();
	notifications();
	products();
	ajaxLoader();
	searchFilters();
	clearFilters();
	woocommerce();
	cart();
	new AutoComplete();
});
